import React, { useEffect, useState } from 'react'
import RestaurantContact from './RestaurantContact';
import {useNavigate, Link} from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import logo from "../../icons/GR_logo_beige_with_name.png"
import axios from 'axios';
const Footer = (props) => {
    const navigate = useNavigate();
    
    const email = 'Msalgado0105@gmail.com'

    return (
        <footer id='footer' className='footer'>
            <img className='footer-logo' src={logo} alt="" />
            <div className='footer-sections'>
                <div className="footer-section footer-locations">
                    <h3 className='footer-title title-locations'>Locations</h3>
                    <div className='footer-locations-content'>  
                        <RestaurantContact 
                        restaurant_location="West Chester" 
                        street_address="200 Painters Crossing Village" 
                        city_address="West Chester, PA 19382" 
                        phone_number="4848400323"
                        email=""
                        gr_link='https://www.granrodeopa.com/'
                        ig_link ="none"
                        fb_link = "https://www.facebook.com/GranRodeoPA"/>
                        <RestaurantContact 
                        restaurant_location="Montgomeryville" 
                        street_address="550 Dekalb Pike" 
                        city_address="North Wales, PA 19454" 
                        phone_number="2672177047"
                        gr_link='https://www.granrodeobarandgrill.com/montgomeryville'
                        ig_link ="https://www.instagram.com/granrodeomontgomeryville/"
                        fb_link = "https://www.facebook.com/granrodeomontgomeryville"/>
                    </div>
                </div>
                <div className="footer-section">
                    <h3 className='footer-title title-browse'>Browse</h3>
                    <Link className='footer-link' to={'/'}>Home</Link>
                    <Link className='footer-link' to={'https://storage.googleapis.com/wzukusers/user-34445303/documents/cbbb86841b0d490185bacecb7d18387b/Gran%20Rodeo%20Menu%202024.pdf'} target='_blank'>Menu</Link>
                    <HashLink className='footer-link' smooth to={'/#hours-of-operation'}>Hours</HashLink>
                    <Link className='footer-link' to={'/OnlineOrder'}>Order Online</Link>
                </div>
                
                <div className="footer-section footer-contact">
                    <h3 className='footer-title title-contact'>Contact</h3>
                    <span>Email: <a className='bold' href={`mailto:${email}`}>{email}</a></span>
                    <span>Call: <a className='phone-link' href="tel:4848400323">(484) 840-0323</a></span>
                </div>
            </div>
            <div className='copyright'>
                <Link>Website designed by<br/><span className='bold'>WebDesign by Woodbridge</span></Link>
                <p>&copy; 2025 Gran Rodeo</p>
            </div>
        </footer>
    )
}
export default Footer;
